/**
 *
 * Description. Private Route
 *
 * @link   URL
 * @file   In any page where login is required then this function is used.
           It check whether user is logged in or not and then only user can see
           pages
 * @since  1.0.0
 */
import React from "react";
import { Route, Redirect } from "react-router-dom";
import app from "../helpers/appGlobal";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (app.user.id) {
        return <Component {...props} />;
      }
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location }
          }}
        />
      );
    }}
  />
);

export default PrivateRoute;
